// extracted by mini-css-extract-plugin
module.exports = {"container":"no_link_legislation_title-module__container--xngIA","iconWrapper":"no_link_legislation_title-module__iconWrapper--3aK9L"};